import React, { useEffect, useState } from "react";
import { FaFilter } from "react-icons/fa";
import { getUserLogs } from "../controllers/utilityController";
import { ButtonComponent, DataTable } from "../components/ui";

function UserLogsPage() {
  const [logs, setLogs] = useState([
    {
      name: "Ali",
      activity: "Logged in",
      timestamp: "2025-01-03T10:15:00Z",
    },
    {
      name: "John Miller",
      activity: "Created new employee",
      timestamp: "2025-01-03T11:22:00Z",
    },
    {
      name: "Sarah Khan",
      activity: "Updated profile",
      timestamp: "2025-01-04T09:02:00Z",
    },
  ]);
  //eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");

  useEffect(() => {
    fetchLogs();
   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    try {//eslint-disable-next-line no-unused-vars
      const res = await getUserLogs();
      setLogs(logs);
    } catch (err) {
      console.error("Error fetching logs:", err);
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    setSearchTerm("");
    setAppliedSearch("");
  };

  const formatDateTime = (timestamp) => {
    const optionsDate = { year: "numeric", month: "long", day: "2-digit" };
    const optionsTime = { hour: "2-digit", minute: "2-digit", hour12: true };

    const date = new Date(timestamp);
    const formattedDate = date.toLocaleDateString("en-US", optionsDate);
    const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

    return `${formattedDate} at ${formattedTime}`;
  };

  const filteredLogs = logs.filter((log) =>
    log.name.toLowerCase().includes(appliedSearch.toLowerCase())
  );

  const rows = filteredLogs.map((log, index) => ({
    id: index + 1,
    Number: index + 1,
    Employee_Name: log.name,
    Activity: log.activity,
    Timestamp: formatDateTime(log.timestamp),
  }));

  return (
    <div className="p-5 w-full max-w-full">
      <div className="sticky top-[73px] z-10 bg-white pb-1">
        <div className="flex flex-col md:flex-row items-center gap-6 mb-6 p-4 bg-gray-50 rounded-lg shadow-lg">
          <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-gray-300 shadow-md">
            <FaFilter className="text-gray-600" />
            <span className="font-semibold text-gray-700">Filter By Name</span>
          </div>

          <input
            type="text"
            placeholder="Search by Name…"
            className="w-42 md:w-50 border rounded-lg px-4 py-2 text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition ease-in-out duration-200"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <ButtonComponent
            onClick={() => setAppliedSearch(searchTerm)}
            className="bg-[#2470B7] hover:bg-[#2470B7] text-white py-2 px-6 rounded-lg shadow-md transition duration-200 ease-in-out transform hover:scale-105"
          >
            Apply Filter
          </ButtonComponent>

          {appliedSearch && (
            <button
              onClick={clearFilters}
              className="bg-gray-500 hover:bg-gray-600 text-white py-2 px-6 rounded-lg shadow-md transition duration-200 ease-in-out transform hover:scale-105"
            >
              Clear Filter
            </button>
          )}
        </div>
      </div>

      <DataTable
        data={rows}
        pages={true}
        excludeColumns={[]} // show all columns
      />
      {/* <div className="overflow-auto rounded pt-0">
        <table className="w-full text-lg bg-white border border-gray-300">
          <thead className="bg-gray-100 text-gray-700">
            <tr className="border-b border-gray-300">
              <th className="px-4 py-3 text-left border-r border-gray-300">
                #
              </th>
              <th className="px-4 py-3 text-left border-r border-gray-300">
                Employee Name
              </th>
              <th className="px-4 py-3 text-left border-r border-gray-300">
                Activity
              </th>
              <th className="px-4 py-3 text-left">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="border-b border-gray-300">
                <td colSpan="4" className="text-center py-4">
                  Loading Logs…
                </td>
              </tr>
            ) : filteredLogs.length === 0 ? (
              <tr className="border-b border-gray-300">
                <td colSpan="4" className="text-center py-4">
                  No matched logs
                </td>
              </tr>
            ) : (
              filteredLogs.map((log, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 text-gray-700 border-b border-gray-300"
                >
                  <td className="px-4 py-2 border-r border-gray-300">
                    {index + 1}
                  </td>
                  <td className="px-4 py-2 border-r border-gray-300">
                    {log.name}
                  </td>
                  <td className="px-4 py-2 border-r border-gray-300">
                    {log.activity}
                  </td>
                  <td className="px-4 py-2">{formatDateTime(log.timestamp)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div> */}
    </div>
  );
}

export default UserLogsPage;
